import React from 'react';
import { observer } from 'mobx-react';
import { EmailTemplatesVM } from '../email-templates.viewmodel';
import { EMAIL_TEMPLATES_LIST_EMPTY, EMAIL_TEMPLATES_PAGE_TITLE, NEW_EMAIL_TEMPLATE, REPLY_TO, TEMPLATE_NAME, TO } from '../email-templates.text';
import { ITheadSort, ListLayout } from '../../global/tables/table-list-layout';
import { DESCRIPTION } from '../../../constants/common-labels.constants';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../api/roles.dao';
import DefaultButton from '../../global/default-button/default-button';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { IEmailTemplateField } from '../../../api/email-templates.dao';
import EmailTemplatesListItem from './email-templates-list-item/email-templates-list-item';

interface IEmailTemplatesListProps {
    vm: EmailTemplatesVM;
}

const EmailTemplatesList = observer(({
    vm
} : IEmailTemplatesListProps) => {
    const {
        intl,
        isLoading,
        templatesList,
        showCreateTemplateForm,
        openEditBlueprintForm,
        isTemplateEditFormShown,
    } = vm;
    const isEmpty = !isLoading && !templatesList.length;
    const createEmailTemplatePermission = hasPermission(Permission.CREATE_EMAIL_TEMPLATES);
    const editEmailTemplatePermission = hasPermission(Permission.EDIT_EMAIL_TEMPLATES);

    const theads: ITheadSort<string>[] = [
        {
            title: intl.formatMessage(TEMPLATE_NAME),
        },
        {
            title: intl.formatMessage(DESCRIPTION),
        },
        {
            title: intl.formatMessage(TO),
        },
        {
            title: intl.formatMessage(REPLY_TO),
        },
        {
            width: '150px'
        },
    ];

    return (
        <div className='page-container'>
            <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                <h1 className='text-ellipsis'>{intl.formatMessage(EMAIL_TEMPLATES_PAGE_TITLE)}</h1>
                <div className='horizontal-row__align-to-row-end'>
                    <div className='buttons-block'>
                        {createEmailTemplatePermission &&
                            <DefaultButton
                                className='events-list__button-new'
                                modifier='fat'
                                text={intl.formatMessage(
                                    NEW_EMAIL_TEMPLATE,
                                    {
                                        prefix: '+ '
                                    }
                                )}
                                onClick={() => showCreateTemplateForm()}
                            />
                        }
                    </div>
                </div>
            </section>
            <section className='events-list fixed-list-layout'>
                <ListLayout
                    thead={theads}
                    sortOptions={{
                        theads: theads,
                    }}
                >
                    {!isLoading && !isEmpty && templatesList.map((template: IEmailTemplateField) => {
                        return <EmailTemplatesListItem
                            isSelected={isTemplateEditFormShown(template.id)}
                            key={template.id}
                            template={template}
                            openEditBlueprintForm={openEditBlueprintForm}
                            editEmailTemplatePermission={editEmailTemplatePermission}
                        />;
                    })}

                    { isLoading && <TableLoadingRow colSpan={theads.length} />}
                </ListLayout>
                {isEmpty && (
                    <div className='empty-list-message'>
                        {intl.formatMessage(EMAIL_TEMPLATES_LIST_EMPTY)}
                    </div>
                )}
            </section>
        </div>
    );
});

export default EmailTemplatesList;
